
export const openEnigma = (id) => ({
  type: 'OPEN_ENIGMA',
  id,
})

export const closeEnigma = (id) => ({
  type: 'CLOSE_ENIGMA',
  id,
})
export const forceEnigmaStatus = (id, status) => ({
  type: 'FORCE_ENIGMA_STATUS',
  id,
  status,
})

export const submitEnigmaAnswer = (id, answer) => ({
  type: 'SUBMIT_ENIGMA_ANSWER',
  id,
  answer,
})

export const enigmaSolved = (id) => ({
  type: 'ENIGMA_SOLVED',
  id,
  meta: {
    sendServer:true
  }
})

export const enigmaInvalidAttempt = (id) => ({
  type: 'ENIGMA_INVALID_ATTEMPT',
  id,
  meta: { sendServer:true }
})

export const enigmaResetFieldsStatus = (id) => ({
  type: 'ENIGMA_RESET_FIELDS_STATUS',
  id,
})
